// extracted by mini-css-extract-plugin
export var externalLink = "_8m-0";
export var internalLinkLabel = "_8m-1";